export default function searchInterfaceConfig($stateProvider) {
  'ngInject';
  $stateProvider.state('searchEngineFrontend.searchInterface', {
    url: '/index.html?q&f',
    template: '<search-interface></search-interface>',
    reloadOnSearch: false
  });
}



// WEBPACK FOOTER //
// ./src/search-interface/search-interface.config.js